import { Chart as ChartJS, BarElement, LineElement, PointElement, LinearScale, CategoryScale, Title, Tooltip, Legend, } from 'chart.js';
import { Chart } from 'react-chartjs-2';

ChartJS.register( BarElement, LineElement, PointElement, LinearScale, CategoryScale, Title, Tooltip, Legend );

export default function BarLineCombo( { data, height = 400 } ) {
    const formatCurrency = ( value ) => {
        if (value >= 1_000_000) return `$${(value / 1_000_000).toFixed(1)}M`;
        if (value >= 1_000) return `$${(value / 1_000).toFixed(0)}K`;
        return `$${value}`;
    };

    const labels = data.map( ( item ) => item.x );

    const chartData = {
        labels,
        datasets: [
          {
            type: 'bar',
            label: 'Units',
            data: data.map((item) => item.units),
            borderColor: '#36A2EB',
            backgroundColor: '#36A2EB33',
            yAxisID: 'y1',
            tension: 0.4,
          },
          {
            type: 'line',
            label: 'Volume',
            data: data.map((item) => item.volume),
            borderColor: '#FF6384',
            backgroundColor: '#FF638433',
            yAxisID: 'y2',
            tension: 0.4,
          },
        ],
    };

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        interaction: {
          mode: 'index',
          intersect: false,
        },
        stacked: false,
        plugins: {
          title: {
            display: true,
            text: 'Units vs Volume Over Time',
          },
          tooltip: {
            callbacks: {
              label: function (context) {
                const { dataset, parsed } = context;
                const label = dataset.label || '';
                const value = dataset.yAxisID === 'y2' ? formatCurrency(parsed.y) : parsed.y;
                return `${label}: ${value}`;
              },
            },
          },
          legend: {
            position: 'bottom',
          },
        },
        scales: {
          x: {
            ticks: {
                // Angle always at 45 degrees
                minRotation: 20,
                maxRotation: 45,
                autoSkip: false, // optional: disables auto-skipping to preserve all ticks
            },
            title: {
                display: false,
                text: 'Month',
            },
          },
          y1: {
            type: 'linear',
            position: 'left',
            title: {
                display: true,
                text: 'Units',
            },
            ticks: {
                stepSize: 1,
            }
          },
          y2: {
            type: 'linear',
            position: 'right',
            title: {
                display: true,
                text: 'Volume',
            },
            ticks: {
                callback: (value) => formatCurrency(value),
            },
            grid: {
                drawOnChartArea: false,
            },
          },
        },
    };

    return (
        <div style={{ position: 'relative', height: `${height}px`, width: '100%' }}>
            <Chart type='bar' data={chartData} options={options} />
        </div>
    );
}